import {actionCreators} from "../reducers";

/**
 * Set breakpoint
 * 
 * @param {string} breakpoint - Breakpoint name.
 * @return {function(*): void}
 */
export const setBreakpointAction = breakpoint => dispatch => { dispatch(actionCreators.breakpoint.set(breakpoint)); };
